import SelectGenders from '../../../components/SelectGenders/index';
import CountryStateCity from '../../../components/CountryStateCity';
import dayjs from 'dayjs';
import {
  Alert,
  DatePicker,
  Form,
  Card,
  Typography,
  Row,
  Col,
  Input,
  Avatar,
} from 'antd';

import { getAll as getIDTypes } from '../../../api/module/identification_types';
import { CustomSelector } from '../../../components';
import { IsRole, validatorNumbers } from '../../../utils/helpers/helpers';
import { useState } from 'react';
import { UserOutlined } from '@ant-design/icons';

const { Title } = Typography;

const dateFormat = 'YYYY/MM/DD';
const NaturalPersonFormGeneralSection = ({
  readOnly = false,
  initialValues = {},
  divRef,
}) => {
  const [superUser] = useState(IsRole(6));

  function calcularDigitoVerificacion(e, setFieldsValue = () => {}) {
    let myNit = e.target.value;
    let vpri, x, y, z;
    // Se limpia el Nit
    myNit = myNit.replace(/\s/g, ''); // Espacios
    myNit = myNit.replace(/,/g, ''); // Comas
    myNit = myNit.replace(/\./g, ''); // Puntos
    myNit = myNit.replace(/-/g, ''); // Guiones
    // Se valida el nit
    if (isNaN(myNit)) {
      console.log("El nit/cédula '" + myNit + "' no es válido(a).");
      return '';
    }
    // Procedimiento
    vpri = new Array(16);
    z = myNit.length;

    vpri[1] = 3;
    vpri[2] = 7;
    vpri[3] = 13;
    vpri[4] = 17;
    vpri[5] = 19;
    vpri[6] = 23;
    vpri[7] = 29;
    vpri[8] = 37;
    vpri[9] = 41;
    vpri[10] = 43;
    vpri[11] = 47;
    vpri[12] = 53;
    vpri[13] = 59;
    vpri[14] = 67;
    vpri[15] = 71;

    x = 0;
    y = 0;
    for (var i = 0; i < z; i++) {
      y = myNit.substr(i, 1);
      x += y * vpri[z - i];
    }

    y = x % 11;
    const res = y > 1 ? 11 - y : y;
    if (res) {
      setFieldsValue({ digito_verificacion: res });
    } else {
      alert('Verifique el número de documento registrado');
      setFieldsValue({ digito_verificacion: '' });
      setFieldsValue({ numero_identificacion: '' });
    }
  }

  function disabledExpeditionDate(current) {
    return current && current > dayjs().endOf('day');
  }

  function disabledBirthDate(current) {
    return (
      current &&
      !current.isBetween(dayjs().subtract(100, 'years'), dayjs(), 'day', [])
    );
  }

  return (
    <Card
      size={'small'}
      bordered={false}
      title={
        <Title level={3}>
          <Avatar
            size={32}
            icon={<UserOutlined />}
            style={{ backgroundColor: '#20b2aa', color: 'white' }}
            shape="square"
          />{' '}
          Identificación general
        </Title>
      }
    >
      <Row gutter={12} ref={divRef}>
        <Col span={12}>
          <Form.Item
            name="primer_nombre_razon_social"
            label="Nombre(s)"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input allowClear placeholder="Nombre(s)" disabled={readOnly} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="primer_apellido"
            label="Apellidos"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input allowClear placeholder="Apellidos" disabled={readOnly} />
          </Form.Item>
        </Col>
      </Row>
      {!superUser && (
        <Row gutter={12}>
          <Col span={24}>
            <Alert
              style={{ marginBottom: '15px' }}
              message="Atención"
              description={
                'Si la información de su Tipo de documento o Número de documento se encuentra errada, por favor comuníquese con la entidad'
              }
              type={'info'}
              showIcon
            />
          </Col>
        </Row>
      )}
      <Row gutter={12}>
        <Col span={24}>
          <Form.Item
            name="tipo_identificacion"
            label="Tipo de documento"
            rules={[
              {
                required: true,
              },
            ]}
            valuePropName="initialValue"
          >
            <CustomSelector
              endpointFetch={getIDTypes}
              valueName="id"
              labelName="nombre"
              disabled={readOnly || !superUser}
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item noStyle dependencies={['tipo_identificacion']}>
        {({ getFieldValue, setFieldsValue }) => {
          const ti = getFieldValue('tipo_identificacion');
          if ([7, 15].includes(ti)) {
            return (
              <Row gutter={12}>
                <Col span={11}>
                  <Form.Item
                    name="numero_identificacion"
                    label="Número de documento"
                    rules={[
                      {
                        required: true,
                      },
                      validatorNumbers(6),
                    ]}
                  >
                    <Input
                      onBlur={(e) =>
                        calcularDigitoVerificacion(e, setFieldsValue)
                      }
                      allowClear
                      placeholder="Número de documento"
                      disabled={readOnly || !superUser}
                    />
                  </Form.Item>
                </Col>
                <Col span={2}>
                  <Form.Item
                    name="digito_verificacion"
                    label="DV"
                    rules={[
                      {
                        required: true,
                      },
                      {
                        validator(_, value) {
                          if (!value || !isNaN(value)) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            'Verifique el número de documento registrado!',
                          );
                        },
                      },
                    ]}
                  >
                    <Input placeholder="DV" disabled />
                  </Form.Item>
                </Col>
                <Col span={11}>
                  <Form.Item
                    name="numeroDocumentoConfirm"
                    label="Confirme el número de documento"
                    rules={[
                      {
                        required: true,
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (
                            !value ||
                            getFieldValue('numero_identificacion') === value
                          ) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            'El número de documento no coincide!',
                          );
                        },
                      }),
                    ]}
                  >
                    <Input
                      allowClear
                      onPaste={(e) => e.preventDefault()}
                      placeholder="Confirme el número de documento"
                      disabled={readOnly || !superUser}
                    />
                  </Form.Item>
                </Col>
              </Row>
            );
          }

          return (
            <Row gutter={12}>
              <Col span={12}>
                <Form.Item
                  name="numero_identificacion"
                  label="Número de documento"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input
                    allowClear
                    placeholder="Número de documento"
                    disabled={readOnly || !superUser}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="numeroDocumentoConfirm"
                  label="Confirme el número de documento"
                  rules={[
                    {
                      required: true,
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (
                          !value ||
                          getFieldValue('numero_identificacion') === value
                        ) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          'El número de documento no coincide!',
                        );
                      },
                    }),
                  ]}
                >
                  <Input
                    allowClear
                    onPaste={(e) => e.preventDefault()}
                    placeholder="Confirme el número de documento"
                    disabled={readOnly || !superUser}
                  />
                </Form.Item>
              </Col>
            </Row>
          );
        }}
      </Form.Item>
      <Row gutter={12}>
        <Col span={6}>
          <Form.Item
            name="fecha_expedicion_documento"
            label="Fecha de expedición del documento"
            rules={[
              {
                required: true,
                type: 'object',
              },
            ]}
          >
            <DatePicker
              allowClear
              format={dateFormat}
              disabledDate={disabledExpeditionDate}
              placeholder="Fecha de expedición del documento"
              disabled={readOnly}
              style={{ width: '100%' }}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            name="lugar_expedicion_documento"
            label="Lugar de expedición del documento"
            rules={[
              {
                required: true,
              },
              { pattern: /^[^0-9]*$/, message: 'No ingresar números' },
            ]}
          >
            <Input
              placeholder="Lugar de expedición del documento"
              disabled={readOnly}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            name="sexo"
            label="Sexo"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <SelectGenders disabled={readOnly} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            name="fecha_nacimiento"
            label="Fecha de nacimiento"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <DatePicker
              allowClear
              format={dateFormat}
              disabledDate={disabledBirthDate}
              placeholder="Fecha de nacimiento"
              disabled={readOnly}
              style={{ width: '100%' }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={8}>
          <Form.Item
            name="numero_celular"
            label="Teléfono de notificación"
            rules={[
              {
                required: true,
              },
              validatorNumbers(7),
            ]}
          >
            <Input
              allowClear
              placeholder="Teléfono de notificación"
              disabled={readOnly}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="celularConfirm"
            label="Confirme el Teléfono de notificación"
            maxLength={2}
            rules={[
              {
                required: true,
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('numero_celular') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    'El Teléfono de notificación no coincide!',
                  );
                },
              }),
              validatorNumbers(7),
            ]}
          >
            <Input
              allowClear
              onPaste={(e) => e.preventDefault()}
              placeholder="Confirme el teléfono de notificación"
              disabled={readOnly}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="otros_numeros_telefonicos"
            label="Otros números telefónicos"
          >
            <Input
              allowClear
              placeholder="Otros números telefónicos"
              disabled={readOnly}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={18}>
          <Form.Item
            name="notificacion_direccion"
            label="Dirección de notificación"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input
              allowClear
              placeholder="Dirección de notificación"
              disabled={readOnly}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            name="codigo_postal"
            label="Código postal"
            rules={[
              {
                validator(_, value) {
                  if (value != null && value.length > 0) {
                    if (value.length >= 3 && value.length <= 8) {
                      return Promise.resolve();
                    }
                    return Promise.reject('Código postal no válido!');
                  } else {
                    return Promise.resolve();
                  }
                },
              },
            ]}
          >
            <Input allowClear placeholder="Código postal" disabled={readOnly} />
          </Form.Item>
        </Col>
      </Row>
      <CountryStateCity
        countryKey="notificacion_pais"
        stateKey="notificacion_estado"
        cityKey="notificacion_ciudad"
        countryLabel="País de notificación"
        stateLabel="Departamento de notificación"
        cityLabel="Ciudad de notificación"
        country={initialValues.notificacion_pais}
        state={initialValues.notificacion_estado}
        city={initialValues.notificacion_ciudad}
        required={true}
        disabled={readOnly}
      />
      <Row gutter={12}>
        <Col span={12}>
          <Form.Item
            name="notificacion_email"
            label="Correo electrónico de notificación"
            rules={[
              {
                required: true,
                type: 'email',
              },
            ]}
          >
            <Input
              allowClear
              placeholder="Correo electrónico de notificación"
              disabled={readOnly}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="correoConfirm"
            label="Confirme el correo electrónico de notificación"
            rules={[
              {
                required: true,
                type: 'email',
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('notificacion_email') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    'El correo electrónico de notificación no coincide!',
                  );
                },
              }),
            ]}
          >
            <Input
              allowClear
              onPaste={(e) => e.preventDefault()}
              placeholder="Confirme el correo electrónico de notificación"
              disabled={readOnly}
            />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
};

export default NaturalPersonFormGeneralSection;
